import Slider from '@material-ui/core/Slider';
import React from 'react';

function valuetext(value) {
	return `${value}°C`;
}

export default function DoubleRange({ currentMin, currentMax, onChangeRange }) {
	const [value, setValue] = React.useState([currentMin, currentMax]);

	const handleChange = (event, newValue) => {
		setValue(newValue);
		let values = {};
		if (newValue[0] >= newValue[1]) {
			values.max = newValue[0];
			values.min = newValue[1];
		} else {
			values.max = newValue[1];
			values.min = newValue[0];
		}
		onChangeRange(values);
	};

	return (
		<Slider
			getAriaLabel={() => 'Temperature range'}
			value={value}
			onChange={handleChange}
			valueLabelDisplay="auto"
			getAriaValueText={valuetext}
			min={0}
			max={500}
		/>
	);
}
